import { Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/modal';
import InputField from 'components/fields/InputField';
import { MdClose } from 'react-icons/md';
import { useState } from 'react';

const ApiKeyModal = (props: {
    isOpen: boolean;
    onClose: () => void;
    serviceName: string;
    onSave: (apiKey: string) => void;
    loading?: boolean;
}) => {
    const { isOpen, onClose, serviceName, onSave, loading } = props;
    const [apiKey, setApiKey] = useState('');

    const handleSave = () => {
        if (apiKey.trim()) onSave(apiKey);
    };

    const handleClose = () => {
        setApiKey('');
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} scrollBehavior="inside">
            <ModalOverlay className="bg-[#000] !opacity-30" />
            <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] border-none p-0 shadow-none focus:outline-none md:top-[12vh]">
                <ModalBody>
                    <div className="relative flex flex-col rounded-2xl border border-leadrs-stroke bg-white px-8 py-8 !z-[1004] max-w-[550px]">
                        <button
                            className="absolute right-5 top-5 text-leadrs-text-soft hover:text-leadrs-text transition-colors"
                            onClick={handleClose}
                        >
                            <MdClose size={20} />
                        </button>

                        <h2 className="font-crimson text-2xl font-semibold text-leadrs-text">
                            Configurer {serviceName}
                        </h2>
                        <p className="mt-2 mb-6 font-geist text-sm text-leadrs-text-soft">
                            Veuillez entrer votre clé API {serviceName} pour connecter votre compte.
                        </p>

                        <InputField
                            label="Clé API"
                            placeholder="Entrez votre clé API"
                            id="apiKey"
                            type="text"
                            defaultValue={apiKey}
                            onChange={(e: any) => setApiKey(e.target.value)}
                            extra="mb-6"
                        />

                        <div className="flex gap-3">
                            <button
                                className="flex h-10 flex-1 items-center justify-center rounded-xl border border-leadrs-stroke font-geist text-sm font-medium text-leadrs-text hover:bg-leadrs-bg transition-colors disabled:opacity-50"
                                onClick={handleClose}
                                disabled={loading}
                            >
                                Annuler
                            </button>
                            <button
                                className="flex h-10 flex-1 items-center justify-center rounded-xl bg-leadrs-brand font-geist text-sm font-medium text-white hover:opacity-80 transition-opacity disabled:cursor-not-allowed disabled:opacity-50"
                                onClick={handleSave}
                                disabled={!apiKey.trim() || loading}
                            >
                                {loading ? 'Enregistrement...' : 'Enregistrer'}
                            </button>
                        </div>
                    </div>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ApiKeyModal;
